import api from '../api/axiosInstance';

export const retentionSettingsService = {
  get: () => api.get('/api/retention-settings'),
  save: (data: { ociCleanupVerifiedDays: number; ociCleanupUnverifiedDays: number }) =>
    api.post('/api/retention-settings', data),
};
